import  {baseActions}  from "./base.actions";

export const physicianActions = {
   
    gets,
    get,
    getall
    
};


function getall() {
    return baseActions.getall('physician','?islist=true');
}


function gets() {
    return baseActions.getall('physician');
}

function get(id)
{
    return baseActions.get('physician',id);
}
